import React, { useState } from 'react';
import config from '@plone/volto/registry';

/** Render selected media only. Missing assets must not invent page content. */
export default function ContentImage({
  fallback,
  fallbackKey,
  children,
  component,
  ...props
}) {
  const [failedSource, setFailedSource] = useState(null);
  const source =
    props.src ||
    (props.item &&
      JSON.stringify([
        props.item['@id'],
        props.item.image_field,
        props.item.image_scales,
      ]));
  const hasImage =
    props.src ||
    props.item?.image_field ||
    Object.keys(props.item?.image_scales || {}).length;
  const Image = component || config.getComponent({ name: 'Image' }).component;
  if (!hasImage || failedSource === source) return null;
  return (
    <>
      <Image
        {...props}
        onError={(event) => {
          setFailedSource(source);
          props.onError?.(event);
        }}
      />
      {children}
    </>
  );
}
